function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M229.415,73.41c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5c3.15,0,5.713,2.557,5.713,5.699v97.187 c0,8.038-6.539,14.577-14.577,14.577s-14.577-6.539-14.577-14.577V49.955c0-11.414-9.292-20.7-20.714-20.7H20.698 C9.285,29.255,0,38.541,0,49.955V200.16c0,11.161,8.874,20.265,19.93,20.674c0.253,0.026,0.509,0.039,0.769,0.039h177.775h22.077 c16.309,0,29.577-13.268,29.577-29.577V94.109C250.128,82.696,240.836,73.41,229.415,73.41z M15,200.16V49.955 c0-3.143,2.556-5.7,5.698-5.7H185.26c3.15,0,5.714,2.557,5.714,5.7v141.341c0,5.298,1.407,10.271,3.857,14.577H20.698 C17.556,205.873,15,203.31,15,200.16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.235,92.182h-46.683c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h46.683c4.142,0,7.5-3.358,7.5-7.5 S160.377,92.182,156.235,92.182z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.235,129.518H51.2c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h105.035c4.142,0,7.5-3.358,7.5-7.5 C163.735,132.876,160.377,129.518,156.235,129.518z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.235,166.854H51.2c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h105.035c4.142,0,7.5-3.358,7.5-7.5 C163.735,170.212,160.377,166.854,156.235,166.854z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.738,107.182h29.907c4.142,0,7.5-3.358,7.5-7.5V69.775c0-4.142-3.358-7.5-7.5-7.5c-4.142,0-7.5,3.358-7.5,7.5v22.407 H49.738c-4.142,0-7.5,3.358-7.5,7.5S45.596,107.182,49.738,107.182z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgNews = function SvgNews(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250.128 250.128",
    style: {
      enableBackground: "new 0 0 250.128 250.128"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNews, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/news.e6a9e3e3.svg";
export { ForwardRef as ReactComponent };